import { CallState } from "@b2bportal/core-types";
import type { ShopResults } from "@b2bportal/rbc-activities-api";
import type { ActivitiesShopState } from "./types";

export const initialActivitiesShopState: ActivitiesShopState = {
  activity: {} as ShopResults,
  isActivityUnavailable: false,
  shopCallState: CallState.NotCalled,
  availabilityCallState: CallState.NotCalled,
  shop: undefined,
  shopSearch: undefined,
  shopOptionCallState: CallState.NotCalled,
  shopOptions: {},
  selectedDate: "",
  selectedTimeSlot: undefined,
  selectedParticipants: [],
  selectedBookableItem: undefined,
  reviewsCallState: CallState.NotCalled,
  reviews: [],
  reviewSummary: undefined,
  lastShopOptionRequest: undefined,
};
